import { getApis } from 'library/Apis';
import { useEffect } from 'react';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

export default function Cookies() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://web-static-stage.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/css/main.css';

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return getApis()?.cookies?.active ? (
    <Fragment key='cookies-on'>
      <Helmet>
        <script src='https://web-static-stage.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/js/main.js' />
      </Helmet>
      <div
        id='sicredi-cookies-root'
        politica-pravacidade-url={`${window.location.origin}/assembleias/politica-privacidade`}
        data-dominiouuid={getApis().cookies.uuid}
        data-enviroment={getApis().cookies.env}
      />
    </Fragment>
  ) : (
    <Fragment key='cookies-off' />
  );
}
